import { Link } from '@cbhq/cds-web/typography';

import {
  discordLinkSchema,
  githubRepoSchema,
  qAndASchema,
  twitterLinkSchema,
  twitterOrDiscordLinkSchema,
} from ':cloud/widgets/buildQuest/constants';

export default {
  '1': {
    title: 'Name that product',
    question: (
      <span>
        What CDP product is the subject of this{' '}
        <Link
          underline={false}
          href="https://www.youtube.com/watch?v=zn3p1hFYhp8&list=PL0zEUTVaoPOwCBVzFA1dEdN2fIwtCjmcQ&index=17"
          openInNewWindow
        >
          AMA video
        </Link>
        ?
      </span>
    ),
    hint: (
      <>
        See this video on{' '}
        <Link
          href="https://www.youtube.com/watch?v=zn3p1hFYhp8&list=PL0zEUTVaoPOwCBVzFA1dEdN2fIwtCjmcQ&index=17"
          openInNewWindow
        >
          YouTube
        </Link>
        .
      </>
    ),
    placeholder: 'Answer here',
    answerSchema: qAndASchema,
  },
  '2': {
    title: 'Name that product',
    question: 'What product would you use to sponsor gas for users?',
    hint: (
      <Link
        href="https://docs.cdp.coinbase.com/cdp-apis/docs/welcome"
        openInNewWindow
        underline={false}
      >
        https://docs.cdp.coinbase.com/cdp-apis/docs/welcome
      </Link>
    ),
    placeholder: 'Answer here',
    answerSchema: qAndASchema,
  },
  '3': {
    title: 'AgentKit',
    question:
      'Create an agent using AgentKit and tell it to send 0.01 Base Sepolia ETH to an address of your choosing.',
    description: [
      <span>
        Follow Steps 1-4 in{' '}
        <Link href="https://docs.cdp.coinbase.com/agentkit/docs/quickstart" openInNewWindow>
          this guide
        </Link>{' '}
        to start.
      </span>,
      <span>
        Post a screenshot in the{' '}
        <Link
          href="https://discord.com/channels/1220414409550336183/1296153892043751496"
          openInNewWindow
        >
          #cdp-quest Discord channel
        </Link>{' '}
        and share the link below.
      </span>,
    ],
    hint: '',
    placeholder: 'Add link to your Discord post',
    answerSchema: discordLinkSchema,
  },
  '4': {
    title: 'Autonomous Agent',
    question: 'Create an AgentKit agent and use it in auto mode.',
    description: [
      <span>
        Follow Steps 1-4 in{' '}
        <Link href="https://docs.cdp.coinbase.com/agentkit/docs/quickstart" openInNewWindow>
          this guide
        </Link>{' '}
        to start.
      </span>,
      <span>
        Post a screenshot of your chat on X tagged with #CDPQuest and share a link to the post.
      </span>,
    ],
    hint: '',
    placeholder: 'Add link to your X post here',
    answerSchema: twitterLinkSchema,
  },
  '5': {
    title: 'Onchain App',
    question: (
      <>
        Fork & clone this{' '}
        <Link
          underline={false}
          href="https://github.com/coinbase/onchain-app-template"
          openInNewWindow
        >
          OnchainKit template
        </Link>
        .
        <br />
        <br />
        Share a link to your Github repo.
      </>
    ),
    hint: '',
    placeholder: 'Add link to your repo here',
    answerSchema: githubRepoSchema,
  },
  '6': {
    title: '30 sec Checkout',
    question: (
      <span>
        Add the Checkout component to your OnchainKit template. (doable in{' '}
        <Link href="https://x.com/GainsleyJustin/status/1851644375308148947" openInNewWindow>
          under 30 seconds
        </Link>
        )
      </span>
    ),
    description: [
      <span>
        Follow steps 1-3 of the Quickstart in{' '}
        <Link href="https://onchainkit.xyz/checkout/checkout" openInNewWindow>
          this guide
        </Link>
        .
      </span>,
      <span>
        Post a screenshot of your component on X tagged with #CDPQuest and share a link to the post.
      </span>,
    ],
    hint: '',
    placeholder: 'Add link to your X post here',
    answerSchema: twitterLinkSchema,
  },
  '7': {
    title: 'Final Quest',
    question: (
      <span>
        Build an app using at least 3 different components from our CDP SDK or OnchainKit.
        <br />
        <br />
        Share your app on X or our Discord.
      </span>
    ),
    hint: (
      <span>
        Check out{' '}
        <Link href="https://docs.cdp.coinbase.com/get-started/docs/use-ai-tooling" openInNewWindow>
          this guide
        </Link>{' '}
        to see how you can use AI to help you build with CDP!
      </span>
    ),
    placeholder: 'Add link to your post here',
    answerSchema: twitterOrDiscordLinkSchema,
  },
};
